import { createTheme, ThemeProvider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { Button, } from '@mui/material'
import { BsSearch } from "react-icons/bs";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InputBase from '@mui/material/InputBase';
import Pagination from '@mui/material/Pagination';


const theme = createTheme({
  palette:{
    primary:{
      main:'#671e78'
    }
  }
})

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#FFF',

  border:'1px solid #691e78',
  borderRadius:"100px",
  '&:hover': {
    // backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width:'345px',

  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
   
  },

}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "rgba(103, 30, 120, 0.1)",
    fontFamily:'Gilroy-Bold'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily:'Gilroy-Regular'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor:'pointer',
  "&:nth-of-type(even)": {
    backgroundColor: ' rgba(103, 30, 120, 0.1)'
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
function createData( date, purpose, beneficiary, status) {
  return { date, purpose, beneficiary, status };
}

const rows = [
  createData( '123nf', '20/2/2022','Adeola James','In progress' ),
  createData('123nf', '20/2/2022','Adeola James', 'In progress'),
  createData('123nf', '20/2/2022','Adeola James', 'Closed'),
  createData('123nf', '20/2/2022','Adeola James', 'Successful'),

  
];
const PDA_First = () => {

  return (
 <>
 <ThemeProvider theme={theme}>
   <Box>
          <Box>

<Box
        mt={5}
        sx={{
          border: "1px solid #671E78",
          borderRadius: "20px",
     
        }}
      >
                    <Box sx={{ borderRadius:'20px 20px 0px 0px' ,pt:4, background: 'rgba(103, 30, 120, 0.1)', height:'100px', pl:{xs:2.5}}}>

                    <Search sx={{width:{lg:'345px', md:'330px', sm:'auto', xs:'auto', pl:{xs:6}}}}>
        <SearchIconWrapper>
          <BsSearch />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search…"
          inputProps={{ 'aria-label': 'search' }}
        />
      </Search>
                    </Box>
        <TableContainer 
       
        >
          <Table sx={{ minWidth: 700, fontFamily:'Gilroy-Regular' }} aria-label="customized table">
            <TableHead sx={{  backgroundColor: "rgba(103, 30, 120, 0.1)", width:'100%',}}>
  
              <TableRow>
                
                <StyledTableCell>Admission ID</StyledTableCell>
                <StyledTableCell >Date</StyledTableCell>
                <StyledTableCell >
                School
                </StyledTableCell>
                <StyledTableCell >
                Status
                </StyledTableCell>
                <StyledTableCell>
                
                </StyledTableCell>
             
              </TableRow>
            </TableHead>
            <TableBody sx={{fontFamily:'Gilroy-Regular'}}>
              {rows.map((row, index) => (
                <StyledTableRow key={index} hover >
                 
                  <StyledTableCell component="th" scope="row">
                    {row.date}
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.purpose}
                  </StyledTableCell>
                  <StyledTableCell > {row.beneficiary}</StyledTableCell>
                  <StyledTableCell >
                    {
                      row.status == "In progress" ?
                      <Box sx={{bgcolor:' #671e781a', borderRadius:'5px', textAlign:'center', color:'#671e78'}}>
                      {row.status}
 
                     </Box>:
                     row.status === "Closed"?
                     <Box sx={{bgcolor:'#b32b2b1a', borderRadius:'5px', textAlign:'center', color:'#b32b2b'}}>
                     {row.status}

                    </Box>:
                <Box sx={{bgcolor:'#82b2401a', borderRadius:'5px', textAlign:'center', color:'#82b240'}}>
                {row.status}

               </Box>
                    }
                
                  </StyledTableCell>
            
                  <StyledTableCell  >
                    <Link to="/parentmanagement/admission/dashboard/admissionform">
      <Button variant='outlined' sx={{borderRadius:'20px'}}>View Application</Button></Link>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
     
        </TableContainer>
      </Box>
      <Box sx={{display:'flex', justifyContent:'right', mt:3}}>
        <Pagination count={10} color="primary" />
        </Box>

      
   
</Box>
        </Box>
        </ThemeProvider>
 </>
  )
}

export default PDA_First